import React, { FC } from "react"
import styled from "styled-components"

// components
import CustomPrismicTitle from "../atoms/CustomPrismicTitle"
import CustomRichText from "../atoms/CustomRichText"

// styles
import mq from "../../styles/breakpoints"

// types
import { ITextDescriptionColumns } from "../../prismic-types/slices/text-description-columns"

const TextDescriptionColumns: FC<ITextDescriptionColumns> = ({
  primary,
  items,
}) => {
  const columnsPerRow = primary.columnsPerRow || 2
  return (
    <Container columnsPerRow={columnsPerRow}>
      {items.map((item, index) => (
        <StyledSection key={index}>
          {item.title.length > 0 && <CustomPrismicTitle data={item.title} />}
          {item.description1.length > 0 && (
            <CustomRichText data={item.description1} />
          )}
        </StyledSection>
      ))}
    </Container>
  )
}

export default TextDescriptionColumns

const Container = styled.div<{ columnsPerRow: number }>`
  display: grid;
  grid-template-columns: 1fr;
  gap: 30px;

  ${mq.from.S`
  grid-template-columns: ${({ columnsPerRow }: { columnsPerRow: number }) =>
    `repeat(${columnsPerRow}, 1fr)`}; 
`}
`

const StyledSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
`
